var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProfile = function SvgProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.52,
    height: 18.52,
    viewBox: "0 0 18.52 18.52",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_5_tw\\xF3j_profil"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.52,
    height: 18.52
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_5_tw\\xF3j_profil",
    "data-name": "5 tw\\xF3j profil",
    clipPath: "url(#clip-_5_tw\\xF3j_profil)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439",
    transform: "translate(-57 -478.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M9.262,0a9.262,9.262,0,1,0,9.262,9.262A9.273,9.273,0,0,0,9.262,0Zm0,17.439a8.177,8.177,0,1,1,8.177-8.177A8.186,8.186,0,0,1,9.262,17.439Z",
    transform: "translate(57 478.104)",
    fill: "#a8b0b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M154.8,67.6a3.8,3.8,0,1,0-3.8-3.8A3.8,3.8,0,0,0,154.8,67.6Zm0-6.512a2.714,2.714,0,1,1-2.714,2.714A2.717,2.717,0,0,1,154.8,61.085Z",
    transform: "translate(-88.537 420.274)",
    fill: "#a8b0b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M92.7,301.282A3.8,3.8,0,0,0,89.856,300H83.344a3.8,3.8,0,0,0-2.846,1.282l-.257.291.192.337a7.093,7.093,0,0,0,12.334,0l.192-.337Zm-6.1,3.132a6.024,6.024,0,0,1-5.007-2.688,2.716,2.716,0,0,1,1.751-.641h6.512a2.716,2.716,0,0,1,1.751.641A6.024,6.024,0,0,1,86.6,304.414Z",
    transform: "translate(-20.338 188.958)",
    fill: "#a8b0b6"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile.b109596d.svg";
export { ForwardRef as ReactComponent };